import React from 'react';
import { Box, BoxProps, Body } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';

interface Props extends BoxProps {
  message: string;
}

const ContractorMessage: React.FC<Props> = ({ message, ...restProps }) => (
  <Box alignItems="flex-start" {...restProps}>
    <StaticImage
      quality={100}
      placeholder="blurred"
      alt="home page contractor"
      style={{ width: 108 }}
      src="../../../../assets/images/home_page_contractor.png"
    />
    <Box
      bg="neutral.0"
      py={300}
      px={500}
      maxW="230px"
      flexDir="column"
      alignItems="flex-end"
      shadow="distance300"
      borderRadius="8px"
      borderBottomLeftRadius="0"
      ml={300}
    >
      <Box flexDir="column" alignItems="flex-start">
        <Body
          size={200}
          fontWeight={700}
          letterSpacing="1px"
          mb={100}
          color="brandOrange.500"
        >
          CONTRACTOR
        </Body>
        <Body size={300} fontWeight={600}>
          {message}
        </Body>
      </Box>
    </Box>
  </Box>
);

export default ContractorMessage;
